import { SVGProps } from 'react';

export const SunIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='white'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
    />
    <path d='M12 2V4' stroke={props.stroke || 'white'} strokeWidth='1.5' strokeLinecap='round' />
    <path
      d='M12 20V22'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path d='M4 12H2' stroke={props.stroke || 'white'} strokeWidth='1.5' strokeLinecap='round' />
    <path
      d='M22 12H20'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M19.7777 4.22266L17.5557 6.25424'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M4.22217 4.22266L6.44418 6.25424'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M6.4444 17.5557L4.22217 19.7779'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      opacity='0.5'
      d='M19.7777 19.7773L17.5557 17.5551'
      stroke={props.stroke || 'white'}
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);
